// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2PZU8","inner":"Footer_inner__2nDAf","nextIcon":"Footer_nextIcon__1RKRT","innerLeft":"Footer_innerLeft__2Dipd"};